import React from 'react';
import {ComponenteGerenciarPedidos } from '../../../componentes/componente-gerenciar-pedidos/index'
const GerenciarPedidos = () => {
    return (
        <ComponenteGerenciarPedidos tipo="PEDIDO" titulo="Gerenciar Pedidos"></ComponenteGerenciarPedidos>
    )  
}
 
export {GerenciarPedidos};